import React from 'react';
import styled from 'styled-components';

const Section = styled.section` padding: 5rem 1rem; background: var(--background-dark); `;
const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1.1fr;
  gap: 3rem;
  align-items: center;
  @media (max-width: 900px) { grid-template-columns: 1fr; }
`;

const Copy = styled.div`
  color: var(--text-color);
  .tag {
    display: inline-block;
    padding: 0.35rem 0.9rem; border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.15);
    background: rgba(0,153,0,0.08); color: var(--primary-color);
    font-size: 0.75rem; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase;
    margin-bottom: 1rem;
  }
  h2 { font-size: clamp(1.75rem, 3.2vw, 2.5rem); margin: 0 0 1rem; span { color: var(--primary-color); } }
  .lede { color: var(--text-secondary); line-height: 1.7; margin: 0 0 1.5rem; }
`;

const Points = styled.ul`
  list-style: none; padding: 0; margin: 0;
  li {
    display: flex; gap: 0.85rem; padding: 0.6rem 0;
    color: var(--text-color); line-height: 1.5;
    .dot {
      flex: 0 0 26px; height: 26px; border-radius: 50%;
      background: rgba(0,153,0,0.15); color: var(--primary-color);
      display: inline-flex; align-items: center; justify-content: center;
      font-weight: 800; font-size: 0.85rem;
      margin-top: 2px;
    }
    strong { color: var(--text-color); font-weight: 700; }
    span { color: var(--text-secondary); }
  }
`;

const Media = styled.figure`
  margin: 0;
  aspect-ratio: 4/3;
  border-radius: 1.5rem;
  overflow: hidden;
  border: 1px solid rgba(0, 153, 0, 0.25);
  img { width: 100%; height: 100%; object-fit: cover; display: block; }
`;

const REASONS = [
  { t: 'Licensed and traceable', d: 'Each license is uniquely tied to your purchase — no shared keys, no shady handoffs.' },
  { t: 'Encrypted delivery', d: 'License keys arrive over encrypted email; downloads come from a signed URL.' },
  { t: 'BTC & USDT payment only', d: 'On-chain payments only — no card data collected, no PII stored beyond your email.' },
  { t: 'Discreet, no third-party trackers on checkout', d: 'The pricing/payment pages are ad-tech-free.' },
  { t: '24/7 real-human WhatsApp support', d: 'A real support agent, not a bot, replies within minutes.' },
];

const SecurityTrust: React.FC = () => (
  <Section id="security">
    <Inner>
      <Copy>
        <div className="tag">Security &amp; trust</div>
        <h2>Buy with <span>confidence</span></h2>
        <p className="lede">
          Every flash USDT software license from us is uniquely tied to your purchase and
          delivered securely. We accept BTC and USDT only, keep no card details, and offer
          24/7 real-human support on WhatsApp.
        </p>
        <Points>
          {REASONS.map((r) => (
            <li key={r.t}>
              <span className="dot">✓</span>
              <div><strong>{r.t}</strong> — <span>{r.d}</span></div>
            </li>
          ))}
        </Points>
      </Copy>
      <Media>
        <img src="/img/security-trust.jpg" alt="Secure flash USDT software delivery — licensed and encrypted" />
      </Media>
    </Inner>
  </Section>
);

export default SecurityTrust;
